// extracted by mini-css-extract-plugin
export var label = "_hn-0";
export var treatmentCard = "_hn-1";